import abl from '../abl';
import schools from '../schools';
import processUnscheduledMeetings from './helpers/process_unscheduled_meetings';

const ScheduleAPI = abl.createClass({
	
	initialize: function(props) {
		this.requestor = props.requestor || {};
	},

	getList: function(props) {
		const promise = new Promise((resolve, reject) => {
			const scheduleInfo = this._getScheduleInfo(props.school, props.term);

			if(scheduleInfo && scheduleInfo.type === 'sheet') {
				this.requestor.getFiles({
					term: scheduleInfo.id
				})
				.then(
					function(response) {
						resolve(response.result.files);
					},
					function(err) {
						reject(err);
					}
				);
			}
			else {
				reject({ message: 'Could not find schedule' });
			}
		});

		return promise;
	},

	get: function(props) {
		const promise = new Promise((resolve, reject) => {
			const scheduleInfo = this._getScheduleInfo(props.school, props.term, props.scheduleId);
			if(scheduleInfo && scheduleInfo.type === 'sheet') {
				const ranges = scheduleInfo.version === 1.0 ?
					['School', 'Teachers', 'Meetings'] :
					['School', 'Staff', 'Cohorts', 'Meetings'];
				this.requestor.getSheet({
					spreadsheetId: props.scheduleId,
					version: scheduleInfo.version,
					ranges: ranges,
					majorDimension: 'ROWS'
				})
				.then(
					function(response) {

						response.scheduledMeetings = processUnscheduledMeetings(
							response.scheduledMeetings
						);
						
						resolve(response);
					},
					function(err) {
						reject(err);
					}
				);
			}
			else {
				reject({ message: 'Could not find schedule' });
			}
		});

		return promise;
	},

	
	_getScheduleInfo: function(school, term) {
		let info;
		if(schools[school] && schools[school].terms[term]) {
			info = schools[school].terms[term];
		}
		return info;
	},

	_getColumnName: function(column) {
    let name = '';
    let startCode = 'A'.charCodeAt(0);
    let remainder;

    while (column > 0) {
      remainder = (column - 1) % 26;
      name = String.fromCharCode(startCode + remainder) + name;
      column = parseInt((column - remainder) / 26, 10);
    }

    return name;
	}
});

export default ScheduleAPI;


/** WEBPACK FOOTER **
 ** ./src/js/clients/schedule_api.js
 **/